import { Carousel } from 'react-responsive-carousel'
import { makeStyles } from '@material-ui/core/styles'
import buyHealthInsurance from 'src/assets/Buy_Policy_Images/buy_health.svg'
import claimAndSupport from 'src/assets/Buy_Policy_Images/clean_support.svg'
import InsuranceMotto from 'src/assets/Buy_Policy_Images/donot_want.svg'
import FounderImage from 'src/assets/Buy_Policy_Images/FounderImage.svg'
import BannerTrovity from 'src/assets/Buy_Policy_Images/BannerTrovity.svg'
import lifeInsurance from 'src/assets/Buy_Policy_Images/buyInsurancePolicyLogo.svg'
import { INSURANCE_CONSTANTS } from 'src/utils/constants/BuyPolicyLife'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { INSURANCE_POLICIES_LIST } from 'src/utils/constants/common'

const HealthInsuranceCarousel = ({ title }) => {
  const classes = useStyles()
  const setImage =
    title === INSURANCE_CONSTANTS?.HEALTH ? buyHealthInsurance : lifeInsurance

  const setTitle = useSelector((state) => state?.buyPolicyTitle?.title)
  const [insuranceTitle, setInsuranceTitle] = useState(setTitle)

  useEffect(() => {
    if (setTitle === '') {
      setInsuranceTitle(INSURANCE_POLICIES_LIST?.INSURANCE)
    }
  }, [setTitle])

  return (
    <>
      <Carousel
        infiniteLoop={true}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        showIndicators={true}
        autoPlay={true}
        stopOnHover={true}
        width={'100%'}
      >
        <div className={classes.carouselItem}>
          <div>
            <div className={classes.imagesContainer}>
              {title === INSURANCE_CONSTANTS?.HEALTH ? (
                <div>
                  <img
                    src={buyHealthInsurance}
                    alt={'Buy Health Insurance'}
                    className={classes.buyHealthInsurance}
                  />
                </div>
              ) : (
                <div className={classes.buyInsuranceContainer}>
                  <img
                    src={setImage}
                    alt={`Buy ${title} Insurance`}
                    className={classes.buyHealthInsuranceImage}
                  />
                  <p className={classes.buyInsuranceTitle}>
                    <span className={classes.buyTitle}>Buy</span>{' '}
                    {insuranceTitle}
                  </p>
                </div>
              )}
              <img
                src={claimAndSupport}
                alt='Claim & Support'
                className={classes.claimAndSupportImage}
              />
            </div>
            <div className={classes.imagesContainer}>
              <img
                src={InsuranceMotto}
                alt='Motto'
                className={classes.insuranceMottoImage}
              />
            </div>
          </div>
        </div>
        <div className={classes.carouselItem}>
          <div className={classes.introductionContainer}>
            <div className={classes.introductionHeadingContainer}>
              <span className={classes.introductionHeading}>
                Sit back & CHILLAX!
              </span>
              <span
                className={`${classes.introductionHeading} ${classes.trovityIntroduction}`}
              >
                Trovity Hai Naa..
              </span>
            </div>
            <div className={classes.founderImageContainer}>
              <img
                src={FounderImage}
                alt='Founder'
                className={classes.founderImage}
              />
            </div>
            <div className={classes.introductionContentContainer}>
              <span className={classes.introductionContent}>
                Hey,
                <br />
                <span className={classes.nameText}>I’m Ram</span>&nbsp;
                <span className={classes.coFounderText}>(Co-founder)</span>
              </span>
              <span className={classes.missionText}>
                Our startup&apos;s mission is to <br />
                <b className={classes.simplifyText}>simplify insurance.</b>
              </span>
            </div>
          </div>
        </div>
        <div className={classes.carouselImage}>
          <img src={BannerTrovity} alt='Trovity' />
        </div>
      </Carousel>
    </>
  )
}

export default HealthInsuranceCarousel

const useStyles = makeStyles({
  carouselItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px',
  },
  buyInsuranceContainer: {
    borderRadius: '40px',
    display: 'flex',
    gap: '10px',
    padding: '5px 10px',
    boxShadow: '5px 4px #EF669B',
    width: '50%',
  },
  buyInsuranceTitle: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: '500',
  },
  buyTitle: {
    color: '#EF669B',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '14px',
    marginBottom: '10px',
  },
  imagesContainer: {
    display: 'flex',
    marginBottom: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '30px',
    flexWrap: 'wrap',
    width: '100%',
  },
  buyHealthInsuranceImage: {
    width: '20% !important',
  },
  claimAndSupportImage: {
    maxWidth: '175px',
    maxHeight: '50px',
    width: '100%',
    height: '100%',
  },
  insuranceMottoImage: {
    maxWidth: '570px',
    maxHeight: '140px',
    width: '100%',
    height: '100%',
  },
  introductionContainer: {
    display: 'flex',
    gap: '5px',
  },
  introductionHeadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '75px',
  },
  introductionHeading: {
    fontFamily: 'Risque',
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: '41px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: '#4DC3E3',
  },
  trovityIntroduction: {
    color: '#EF669B',
  },
  founderImageContainer: {},
  founderImage: {
    width: '100%',
    height: '100%',
    maxWidth: '130px',
    maxHeight: '311px',
  },
  introductionContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginBottom: '30px',
    textAlign: 'left',
  },
  introductionContent: {
    fontFamily: 'Risque',
    fontSize: '22px',
    fontWeight: 400,
    letterSpacing: '0em',
  },
  nameText: {
    fontFamily: 'Risque',
    fontSize: '30px',
  },
  coFounderText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    letterSpacing: '0em',
  },
  missionText: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0em',
  },
  simplifyText: {
    fontSize: '18px',
  },
  integrityContainer: {
    display: 'flex',
    gap: '15px',
  },
  integrityContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '25px',
    textAlign: 'left',
    marginTop: '30px',
    padding: '15px',
  },
  integrityHeadingContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  discoverText: {
    color: '#4DC3E3',
    fontFamily: 'Risque',
    fontSize: '22px',
    fontWeight: 400,
    letterSpacing: '0em',
  },
  integrityText: {
    fontFamily: 'Risque',
    fontSize: '22px',
    fontWeight: 400,
    letterSpacing: '0em',
  },
  goalText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0em',
    color: '#5E5E5E',
  },
  separator: {
    width: '100%',
    border: '1px dashed #5E5E5E',
    opacity: '0.3',
  },
  insuranceContentContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  insuranceContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0em',
  },
  insuranceText: {
    color: '#EF669B',
  },
  carouselImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 50px',
  },
})
